export default __webpack_public_path__ + "static/media/coyote.b44e9018.webp";